import { cssClass } from "@/utils/styled";
import { themeVars as tv } from "@/utils/theme";
import { defineComponent, h, type PropType } from "vue";

const toastContentClass = cssClass`
  display: flex;
  padding: 8px;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  background: ${tv.colors.toastBackground};
`;

const pointsBadgeClass = cssClass`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to right, ${tv.colors.accentLight}, ${tv.colors.accentDark});
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  overflow: hidden;
  border: 0.5px solid ${tv.colors.borderLight};
  width: 40px;
  height: 40px;
`;

const pointsInnerClass = cssClass`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 0.5px solid ${tv.colors.borderLight};
  border-radius: 50%;
  flex: 1;
  width: 100%;
  margin: 1px;
  aspect-ratio: 1;
  overflow: hidden;
  border-style: dotted;
  border-spacing: 0.5px;
`;

const pointsTextClass = cssClass`
  color: ${tv.colors.white};
  font-weight: bold;
  font-family: ${tv.fonts.sans};
  font-size: 0.8725rem;
  font-style: normal;
  font-weight: 800;
  line-height: 100%;
  text-transform: uppercase;
`;

const toastMessageClass = cssClass`
  color: ${tv.colors.white};
  font-family: ${tv.fonts.sans};
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`;

export const ToastNotification = defineComponent({
  setup: (props, { slots }) => {
    return () =>
      h("div", { class: toastContentClass }, [
        h("div", { class: pointsBadgeClass }, [
          h("div", { class: pointsInnerClass }, [
            h("span", { class: pointsTextClass }, `+${props.points}`),
          ]),
        ]),
        h("p", { class: toastMessageClass }, slots.default?.()),
      ]);
  },
  props: {
    points: {
      type: Number as PropType<number>,
      required: true,
    },
  },
});
